import React, { useState } from "react";
import Loading from "react-fullscreen-loading";
import { useTranslation } from "react-i18next";
import * as dateHelper from "../../Helpers/DateHelper";
import { tenantService } from "../../Services/tenant.service";
import ResultModal from "../Common/ResultModal";
import { principals } from "../../Config/Principals";
import { serialize } from "object-to-formdata";

const Confirm = (props) => {
  const goTo = () => {
    props.nextStep();
  };

  const back = () => {
    props.prevStep();
  };

  const {
    createTenantData,
    createUserData,
    createStoreData,
    createPosData,
    uploadCertificateData,
  } = props;

  const { t: translator } = useTranslation();
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { ht, iskon } = principals;

  const handleClose = () => {
    setModal({ show: false });
  };

  var submitData = {
    createTenantData,
    createUserData,
    createStoreData,
    createPosData,
  };

  const formData = serialize(submitData);

  // cert
  formData.append(
    "uploadCertificateData.fileContent",
    uploadCertificateData.fileContent
  );
  formData.append("uploadCertificateData.name", uploadCertificateData.name);
  formData.append(
    "uploadCertificateData.certPassword",
    uploadCertificateData.certPassword
  );
  formData.append(
    "uploadCertificateData.validFrom",
    dateHelper.datePickerDateToUtc(uploadCertificateData.validFrom)
  );
  formData.append(
    "uploadCertificateData.validTo",
    dateHelper.datePickerDateToUtc(uploadCertificateData.validTo)
  );
  formData.append(
    "principalId",
    window.REACT_APP_VENDOR === "ht" ? ht : ht
  );

  const handleSubmit = () => {
    setIsLoading(true);
    tenantService
      .onboarding(formData)
      .then((res) => {
        setIsLoading(false);

        res.status == 200
          ? goTo()
          : setModal({
              show: true,
              title: translator("Onboarding-UnsuccesModal-Title"),
              text: translator("Onboarding-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("Onboarding-UnsuccesModal-Title"),
          text: translator("Onboarding-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <>
      <div className="row pl-3">
        <div className="col-md-4 col-sm-12">
          <h6>{translator("Onboarding-DataVerification-RowTitle-Tenant")}</h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-TenantOIB")}:
              </strong>{" "}
              {createTenantData.taxNumber}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-TenantName")}:
              </strong>{" "}
              {createTenantData.name.length >= 30
                ? `${createTenantData.name.substring(0, 30)}...`
                : createTenantData.name}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-TenantPassword")}:
              </strong>{" "}
              {createTenantData.code}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-TenantOwner")}:
              </strong>{" "}
              {createTenantData.owner.length >= 30
                ? `${createTenantData.owner.substring(0, 30)}...`
                : createTenantData.owner}
            </li>
            <li className="list-group-item">
              <strong>IBAN:</strong> {createTenantData.iban}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-TenantAdress")}:
              </strong>{" "}
              {createTenantData.street.length >= 30
                ? `${createTenantData.street.substring(0, 30)}...`
                : createTenantData.street}{" "}
              , {createTenantData.streetNumber}{" "}
              {createTenantData.streetNumberExtension}
            </li>
          </ul>
          <br />
        </div>
        <div className="col-md-4 col-sm-12">
          <h6>{translator("Onboarding-DataVerification-RowTitle-User")}</h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-UserOIB")}:
              </strong>{" "}
              {createUserData.personalIdentificationNumber}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-UserFullName")}:
              </strong>{" "}
              {createUserData.realName.length >= 30
                ? `${createUserData.realName.substring(0, 30)}...`
                : createUserData.realName}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-UserName")}:
              </strong>{" "}
              {createUserData.loginName}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-UserPrintName")}:
              </strong>{" "}
              {createUserData.printName}
            </li>
            <li className="list-group-item">
              <strong>Email:</strong> {createUserData.email}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-UserPhoneNumber")}:
              </strong>{" "}
              {createUserData.phone}
            </li>
          </ul>
          <br />
        </div>
        <div className="col-md-4 col-sm-12">
          <h6>{translator("Onboarding-DataVerification-Store")}</h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreDescription")}:
              </strong>{" "}
              {createStoreData.description.length >= 30
                ? `${createStoreData.description.substring(0, 30)}...`
                : createStoreData.description}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreTag")}:
              </strong>{" "}
              {createStoreData.tag}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreNote")}:
              </strong>{" "}
              {createStoreData.footerNote.length >= 30
                ? `${createStoreData.footerNote.substring(0, 30)}...`
                : createStoreData.footerNote}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreAdress")}:
              </strong>{" "}
              {createStoreData.street.length >= 30
                ? `${createStoreData.street.substring(0, 30)}...`
                : createStoreData.street}{" "}
              , {createStoreData.streetNumber}{" "}
              {createStoreData.streetNumberExtension}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreCity")}:
              </strong>{" "}
              {createStoreData.city}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-StoreZipCode")}:
              </strong>{" "}
              {createStoreData.postalNumber}
            </li>
          </ul>
          <br />
        </div>
        <div className="col-md-4 col-sm-12">
          <h6>{translator("Onboarding-DataVerification-POS")}</h6>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-POSDescription")}:
              </strong>{" "}
              {createPosData.description.length >= 30
                ? `${createPosData.description.substring(0, 30)}...`
                : createPosData.description}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-POSTag")}:
              </strong>{" "}
              {createPosData.tag}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-POSSerialNumber")}:
              </strong>{" "}
              {createPosData.posSerialNumber}
            </li>
            <li className="list-group-item">
              <strong>TID:</strong> {createPosData.tid}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-POSSubcriptionFrom")}:
              </strong>{" "}
              {dateHelper.formatUtcToDate(createPosData.subscriptionValidFrom)}
            </li>
            <li className="list-group-item">
              <strong>
                {translator("Onboarding-DataVerification-POSSubcriptionTo")}:
              </strong>{" "}
              {dateHelper.formatUtcToDate(createPosData.subscriptionValidTo)}
            </li>
          </ul>
          <br />
        </div>
        {uploadCertificateData.fileContent != null ? (
          <div className="col-md-4 col-sm-12">
            <h6>{translator("Onboarding-DataVerification-Certificate")}</h6>
            <ul className="list-group">
              <li className="list-group-item">
                <strong>
                  {translator("Onboarding-DataVerification-CertName")}:
                </strong>{" "}
                {uploadCertificateData.name !== ""
                  ? uploadCertificateData.name
                  : translator("No-Data")}
              </li>
              <li className="list-group-item">
                <strong>
                  {translator("Onboarding-DataVerification-CertValidFrom")}:
                </strong>{" "}
                {uploadCertificateData.validFrom !== ""
                  ? dateHelper.formatUtcToDate(uploadCertificateData.validFrom)
                  : translator("No-Data")}
              </li>
              <li className="list-group-item">
                <strong>
                  {translator("Onboarding-DataVerification-CertValidTo")}:
                </strong>{" "}
                {uploadCertificateData.validTo !== ""
                  ? dateHelper.formatUtcToDate(uploadCertificateData.validTo)
                  : translator("No-Data")}
              </li>
            </ul>
            <br />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="row pl-3">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={back}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit}>
            {translator("Onboarding-DataVerification-Btn-Save")}
          </button>
        </div>
      </div>
      <Loading
        loading={isLoading}
        background="rgba(60, 60, 60, 0.5)"
        loaderColor={process.env.REACT_APP_COLOR}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </>
  );
};

export default Confirm;
